import { appConfig } from 'config/appConfig';

const { envLabel } = appConfig;

export const resources = {
  email: {
    title: 'Email Nurture Copy',
    description: 'Use this email copy to send to your clients',
    data: [{
      order: '1',
      title: 'Email Nurture for Your Clients',
      thumbnail: '/assets/images/email_thumbnail.jpg',
      content: '/assets/files/Email Drip for DSC.docx',
      badge_label: 'Email Copy',
      summary: 'This email nurture sequence spans six months and comprises four strategically timed emails plus an SMS to inform clients about their eligibility to apply for an FSL loan.',
    }],
  },
  guide: {
    title: 'Guides',
    description: 'Expert tips for compelling marketing messages',
    data: [{
      order: '1',
      title: "Messaging Guide for DSC's",
      thumbnail: '/assets/images/guide_thumbnail.jpg',
      content: '/assets/files/DSC Messaging Guide.pptx',
      badge_label: 'Guide',
      summary: 'This guide equips you with a strategic framework to effectively market your services alongside Freshstart Lending, showcasing a comprehensive approach to engage with potential clients.',
    }],
  },
  landing_page: {
    title: 'Landing Pages',
    description: 'Utilize these landing pages in your marketing materials',
    data: [{
      order: '1',
      title: 'Freshstart Landing Page',
      thumbnail: '/assets/images/landingpage_thumbnail.jpg',
      content: `https://${envLabel && (envLabel === 'dev' || envLabel === 'stage') ? 'next.' : ''}lendingusa.com/freshstart-lending-dsc/`,
      badge_label: 'Landing Page',
      summary: 'This landing page serves as a comprehensive resource, guiding your debt settlement clients through the intricacies of the Freshstart Lending program.',
    }],
  },
};



// WEBPACK FOOTER //
// ./src/containers/pages/MarketingResources/data/resources.js